/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Container, Grid } from "@mui/material";
import InfiniteScroll from "react-infinite-scroll-component";
import MobileSwingRow from "./MobileSwingRow"
import { getSwingHistoryQuery } from "../../../api/swing";
import { AuthContext } from "../../../contexts/AuthContext";
import ListingPlaceHolder from "../../../components/placeHolder/ListingPlaceHolder";
import "./swingHistory.css";

export default function MobileSwingHistory() {
  const { userData } = useContext(AuthContext);
  const [videos, setVideos] = useState([]);
  const [hasMore, setHasMore] = useState(true);
  const [loading, toggleLoading] = useState(true);
  const [lastDoc, setLastDoc] = useState();
  const golferData = useSelector((state) => state.golfer.golferObj);
  let viewAs = false;
  let swingDataOnSnapShot = function () {}; //to unsubscribe onSnapshot on unmount

  useEffect(() => {
    if (golferData?.userId) {
      viewAs = false;
      if (golferData?.userId !== userData?.uid){
        viewAs = true;
      }
      getSwingData(golferData?.userId);
    } else if (userData?.uid) {
      getSwingData(userData?.uid);
      viewAs = false;
    }

    return () => swingDataOnSnapShot();
  }, [userData, golferData]);

  useEffect(() => {
    if (videos.length % 20 !== 0) {
      setHasMore(false);
    }
  }, [videos]);

  // Scroll to the top of the page when opened
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const getSwingData = async (userId) => {
    swingDataOnSnapShot = await getSwingHistoryQuery({
      userId: userId ? userId : golferData?.userId,
      setSwings: setVideos,
      toggleLoading,
      lastDoc,
      setLastDoc,
      existingSwings: videos,
      viewAs,
      loggedinUserId: userData?.uid,
      forMobile: true
    });
  };

  return (
    <Container>
      <Grid
        container
        sx={{ my: 4, flex: 1, display: "flex", flexDirection: "column" }}
      >
        {loading && <ListingPlaceHolder />}
        <InfiniteScroll
          dataLength={videos.length} //This is important field to render the next data
          next={getSwingData}
          hasMore={hasMore}
          loader={
            !loading && (
              <p style={{ textAlign: "center" }}>
                <b>Loading more swings...</b>
              </p>
            )
          }
          scrollThreshold={"100px"}
          style={{maxWidth: '100%'}}
        >
          {!loading &&
            videos.map((item, index) => {
              return <MobileSwingRow videoData={item} key={index} k={index} userId={userData?.uid} />;
            })}
        </InfiniteScroll>
      </Grid>
    </Container>
  );
}
